var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as contactActions from "../../redux/contact/contact.actions";
import * as contactSelectors from "../../redux/contact/contact.selectors";
import { EField } from "./schema.kyc.types";
export var isPerformingSubmitActionSelector = function (user) { return function (state) {
    return contactSelectors.contactIsUpdating(state, user.personalContactId);
}; };
export var performingSubmitActionErrorSelector = function (user) { return function (state) {
    return contactSelectors.contactUpdateError(state, user.personalContactId);
}; };
export var submitActionCreator = function (user) { return function (formData) {
    var contact = __assign({}, formData);
    if (formData[EField.Address]) {
        contact = __assign(__assign(__assign({}, contact), formData[EField.Address]), { countryId: formData[EField.Address].country });
    }
    return contactActions.updateContact.actions.start({
        contactId: user.personalContactId,
        contact: contact,
    });
}; };
